import { IDENTITY_CONFIG } from "../Auth/authConst";

//App

function getOidcStorage(): any{
    const item = sessionStorage.getItem(
        `oidc.user:${IDENTITY_CONFIG.authority}:${IDENTITY_CONFIG.client_id}`
    );

    return item != null ? JSON.parse(item) : null;
};


function getClaims() {
    const oidcStorage = getOidcStorage();
    const userToken = oidcStorage?.profile;
    return userToken;
}

function getIdTokenClaims() {
    const oidcStorage = getOidcStorage();
    const id_token = oidcStorage?.id_token;
    return id_token;
}

function getAccessToken() {
    const oidcStorage = getOidcStorage();
    const access_token = oidcStorage?.access_token;

    return access_token;
}

function getRefreshToken() {
    const oidcStorage = getOidcStorage();
    const refresh_token = oidcStorage?.refresh_token;

    return refresh_token;
}


function updateStorageProfile(profile: any) {
    const oidcStorage = getOidcStorage();
    oidcStorage["profile"] = profile;
    sessionStorage.setItem(`oidc.user:${IDENTITY_CONFIG.authority}:${IDENTITY_CONFIG.client_id}`, JSON.stringify(oidcStorage));
}

export { getClaims, getAccessToken, getIdTokenClaims, getRefreshToken, updateStorageProfile };
